<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<div class="mb-4 !border-none !bg-transparent">
  <div class="p-toolbar-group-left w-full flex flex-col sm:flex-row sm:justify-between gap-2 sm:gap-3 sm:items-center">
    <h2 class="text-lg sm:text-xl md:text-2xl font-bold text-gray-900">Withdrawals Management</h2>
  </div>
</div>

<div class="filters-section mb-4">
  <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
    <div class="flex-grow md:mr-4">
      <div class="relative">
        <input type="text" pInputText placeholder="Search by investor name or email..." [(ngModel)]="searchTerm" (input)="onSearchInput($event)" class="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-500 pr-10">
        <button *ngIf="searchTerm" (click)="clearSearch()" class="absolute top-1/2 right-2 -translate-y-1/2 text-gray-500 hover:text-gray-700">
          <i-lucide name="x" class="h-5 w-5"></i-lucide>
        </button>
      </div>
    </div>
    <div class="status-filter">
      <p-dropdown
        [options]="statusOptions"
        [(ngModel)]="statusFilter"
        optionLabel="label"
        optionValue="value"
        placeholder="Filter by status"
        (onChange)="page = 1; fetch()"
        styleClass="w-full md:w-auto"
      ></p-dropdown>
    </div>
  </div>
</div>

<!-- Loading State -->
<div *ngIf="loading()" class="loading-container">
  <div class="loading-spinner"></div>
  <p>Loading withdrawals...</p>
  
</div>

<!-- Content -->
<div *ngIf="!loading()" class="transactions-table-container overflow-x-auto">
  <p-card class="mb-4">
    <p-table
      [value]="rows()"
      [tableStyle]="{ 'min-width': tableMinWidth }"
      styleClass="w-full"
      [responsiveLayout]="responsiveLayout"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Investor</th>
          <th>Amount</th>
          <th>Status</th>
          <th>Requested At</th>
          <th>Ref #</th>
          <th class="text-right">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-r>
        <tr>
          <td>
            <div class="flex flex-col">
              <span class="font-medium">{{ fullName(r.userId) }}</span>
              <small class="opacity-70" *ngIf="r?.userId?.email">{{ r.userId.email }}</small>
            </div>
          </td>
          <td>AED {{ r.amount | number:'1.2-2' }}</td>
          <td>
            <p-tag [severity]="getSeverity(r.status)" [value]="r.status"></p-tag>
          </td>
          <td>{{ r.createdAt | date:'medium' }}</td>
          <td>{{ r.referenceNumber || '-' }}</td>
          <td class="text-right">
            <div class="flex gap-2 justify-end">
              <button pButton pTooltip="Initiate" icon="pi pi-play" (click)="openAction(r,'initiate')" *ngIf="canInitiate(r.status)"></button>
              <button pButton pTooltip="Process" icon="pi pi-arrow-right" (click)="openAction(r,'process')" *ngIf="canProcess(r.status)"></button>
              <button pButton pTooltip="Complete" icon="pi pi-check" severity="success" (click)="openAction(r,'complete')" *ngIf="canComplete(r.status)"></button>
              <button pButton pTooltip="Reject" icon="pi pi-times" severity="danger" (click)="openAction(r,'reject')" *ngIf="canReject(r.status)"></button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" style="text-align: center;" class="text-center py-8 opacity-70">No withdrawals found</td>
        </tr>
      </ng-template>
    </p-table>

    <p-paginator
      [rows]="limit"
      [totalRecords]="total()"
      [first]="(page - 1) * limit"
      (onPageChange)="pageChange($event)"
      [rowsPerPageOptions]="[10,20,50,100]"
      styleClass="mt-2"
    ></p-paginator>
  </p-card>
</div>

<p-dialog [visible]="showActionDialog()" (onHide)="showActionDialog.set(false)" [modal]="true" [style]="{width:'32rem'}" [draggable]="false" [resizable]="false" header="Update Withdrawal">
  <div class="flex flex-col gap-3">
    <div class="flex flex-col">
      <label class="text-sm mb-1">Reference Number (optional)</label>
      <input pInputText type="text" [ngModel]="actionRef()" (ngModelChange)="actionRef.set($event)" placeholder="e.g. NEFT/TT Ref" />
    </div>
    <div class="flex flex-col">
      <label class="text-sm mb-1">Admin Notes (optional)</label>
      <textarea pInputTextarea [ngModel]="actionNotes()" (ngModelChange)="actionNotes.set($event)" rows="3" placeholder="Notes"></textarea>
    </div>
    <div class="flex justify-end gap-2 mt-2">
      <button pButton label="Cancel" (click)="showActionDialog.set(false)"></button>
      <button pButton label="Confirm" severity="primary" (click)="confirmAction()"></button>
    </div>
  </div>
</p-dialog>
